import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import Home from "./Components/Home";
import PrivacyPage from "./Components/PrivacyPage";
import TermsPage from './Components/TermsPage';
import ContributePage from './Components/ContributePage';
import ContactPage from './Components/ContactPage';
const App = () => {

  return (
    <>
      <Router>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/privacy" element={<PrivacyPage />} />
            <Route path="/terms" element={<TermsPage />} />
            <Route path="/contribute" element={<ContributePage />} />
            <Route path="/contact" element={<ContactPage />} />
          </Routes>
       </Router> 
    </>
  );
};

export default App;